import React from 'react';

import { Stack } from '@lyearn/ui';

import { useArticle } from '../../../../articleContext';
import Header from './Header';
import LessonMainContentContainer from './LessonMainContent';
import { MainContentViewProps } from './types';

const MainContent: React.FC<MainContentViewProps> = (props) => {
  const { setHeaderState, headerState } = props;
  const { isDetailsPage, hideAccessories } = useArticle();
  return (
    <Stack
      alignItems="center"
      className="native:items-start relative h-full w-full bg-bg-primary"
      direction="col">
      {!!isDetailsPage || hideAccessories ? null : <Header headerState={headerState} />}
      <LessonMainContentContainer setHeaderState={setHeaderState} />
    </Stack>
  );
};

export default React.memo(MainContent);
